<template>
    <b-card no-body>
        <b-card-header class="border-0 brand-table-headers">
            <div v-if="countriesLoading">
                <h3>Loading...</h3>
            </div>
            <div v-else class="brand-filters">
                <base-input label="Name" placeholder="Name" v-model="filters.name__icontains" />
                <base-input label="Country">
                    <b-dropdown variant="outline-light" :text="countries[filters.country]">
                        <b-dropdown-item v-for="(country,index) in countries" v-bind:key="index" @click="filters.country=index">{{country}}</b-dropdown-item>
                    </b-dropdown>
                </base-input>
            </div>
            
            <router-link :to="'/brand/new'" class="d-flex align-items-center">
                <base-button icon type="info" class="btn btn-info">
                    <span class="btn-inner--icon">
                        <i class="ni ni-fat-add"/>
                    </span>
                </base-button>
            </router-link>
        </b-card-header>
        <card v-if="isLoading || countriesLoading">
            <h4>Loading...</h4>
        </card>
        <el-table v-else
                  class="table-responsive table"
                  header-row-class-name="thead-light"
                  :data="brands">
            <el-table-column label="ID" prop="id"/>
            <el-table-column label="Name" prop="name" />

            <el-table-column label="Country" prop="country">
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        {{countries[row.country]}}
                    </b-media>
                </template>
            </el-table-column>
            
            <el-table-column label="Details" prop="_">
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center justify-content-end">
                        <router-link v-bind:key="row.id" :to="'/brand/'+row.id">
                            <base-button icon type="info">
                                <span class="btn-inner--icon">
                                    <i class="ni ni-align-center"/>
                                </span>
                            </base-button>
                        </router-link>
                    </b-media>
                </template>
            </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="total" @change="pageChanged">
                <template v-slot:prev-text>
                    <a class="page-link" aria-label="Previous">
                        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                    </a>
                </template>
            </base-pagination>
        </b-card-footer>
    </b-card>
</template>

<script>

import {Table,TableColumn} from 'element-ui'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const BrandRepository = RepositoryFactory.get('brand');
const CountryRepository = RepositoryFactory.get('country');

export default {
    name:'brand-table',

    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    data(){
        return{
            currentPage:1,
            total:0,
            brands:null,
            lastRequestTimestamp:0, 

            filters:{country:undefined},
            filterTimer:undefined,

            countriesLoading:true,
            countries:null,

            isLoading:true,
        }
    },
    watch:{
        filters:{
            handler(oldVal,newVal){
                clearTimeout(this.filterTimer);
                this.isLoading=true;
                for(var i in this.filters){
                    if(this.filters[i]==="")
                        delete this.filters[i]
                    }
                this.filterTimer=setTimeout(() => this.getPage(1), 1000);
            },
            deep:true,
        }
    },
    created(){
        this.getPage(1);
        this.getCountries();
    },
    methods:{
        getPage(pageNumber){
            var timestamp=Date.now();
            this.lastRequestTimestamp=timestamp;

            this.currentPage=pageNumber;
            BrandRepository.getTable(pageNumber,this.filters).then((response) => {
                if(this.lastRequestTimestamp!==timestamp) return;

                var r=response.data

                this.brands=r.results;
                this.total=r.count;
                this.currentPage=pageNumber;
                this.isLoading=false;
            })
        },
        pageChanged(pageNumber){
            this.getPage(pageNumber);
        },
        getCountries(){
            this.countriesLoading=true;
            CountryRepository.get().then((response) => {
                this.countries={null:'No country',undefined:'Not selected'}

                for(var i in response.data){
                    var country=response.data[i];
                    this.countries[country.id]=country.name;
                }
                this.countriesLoading=false;
            })
        }
    }


}
</script>

<style>

.brand-table-headers {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
}

.brand-filters{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap:10px;
}


</style>